<template>
  <pt-production-task-list class="pt-production-task-list__page"></pt-production-task-list>
</template>

<script>
import PtProductionTaskList from 'cps/production-task/pt-production-task-list/withData'
export default {
  name: 'pt-production-task-list__view',
  components: {
    'pt-production-task-list': PtProductionTaskList
  }
}
</script>
